import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-zhanghao",
  "use": "icon-icon-zhanghao-usage",
  "viewBox": "0 0 56.5 56.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 56.5 56.5\" id=\"icon-icon-zhanghao\">\n<path fill-rule=\"evenodd\" opacity=\"0\" fill=\"rgb(32, 57, 97)\" d=\"M-0.006,0.006 L55.994,0.006 L55.994,56.006 L-0.006,56.006 L-0.006,0.006 Z\" />\n<path fill-rule=\"evenodd\" stroke=\"rgb(37, 120, 248)\" stroke-width=\"1px\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\" fill=\"none\" d=\"M30.385,29.904 C32.640,29.079 34.260,26.797 34.260,24.118 C34.260,20.735 31.680,18.000 28.504,18.000 C25.328,18.000 22.747,20.743 22.747,24.118 C22.747,26.797 24.367,29.071 26.622,29.904 C22.834,30.875 19.1000,34.695 19.1000,38.1000 L36.999,38.1000 C36.999,34.695 34.173,30.875 30.385,29.904 L30.385,29.904 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-zhanghao.svg
// module id = teEV
// module chunks = 28